const { merge, groupBy } = require('lodash');
const moment = require('moment');
const { SHIPPING_REGIONS_ID_NAME, SHIPPING_REGIONS_ID_COUNTRY, GST_RATE } = require('./constants');

const decorateData = data => {
  const defaultValue = '-';
  const defaultValueForNumber = 0.0;
  const orders = [];
  if (data) {
    data.forEach(item => {
      const orderShipments = groupBy(item.orderLines, 'orderShipment.id');
      Object.keys(orderShipments).forEach(shipmentId => {
        const order = {
          orderid: item.id,
          shipmentid: item.orderLines[0].orderShipment.id,
          orderStatus:
            orderShipments[shipmentId][0].orderShipment.status === 'unhandled' ||
            orderShipments[shipmentId][0].orderShipment.status === 'Placed'
              ? 'pending'
              : orderShipments[shipmentId][0].orderShipment.status,
          shipmentRef: orderShipments[shipmentId][0].orderShipment.reference,
          createdAt: item.createdAt,
          customername: item.deliveryAddress.name,
          trackingNumber: orderShipments[shipmentId][0].orderShipment.consignment
            ? orderShipments[shipmentId][0].orderShipment.consignment
            : '',
          courier: orderShipments[shipmentId][0].orderShipment.carrier
            ? orderShipments[shipmentId][0].orderShipment.carrier
            : '',
          shippingCost: parseFloat(
            orderShipments[shipmentId][0].orderShipment.cost
              ? orderShipments[shipmentId][0].orderShipment.cost
              : 0.0
          ),
          supplierInputCost:
            orderShipments[shipmentId][0].orderShipment.supplierInputCost === null
              ? ''
              : parseFloat(orderShipments[shipmentId][0].orderShipment.supplierInputCost).toFixed(
                  2
                ),

          /**
           * All shipping cost are GST Excluded
           */
          shippingCostWithoutGst: parseFloat(
            parseFloat(
              orderShipments[shipmentId][0].orderShipment.supplierInputCost === null ||
              orderShipments[shipmentId][0].orderShipment.supplierInputCost == undefined
                ? orderShipments[shipmentId][0].orderShipment.cost === null
                  ? 0.0
                  : orderShipments[shipmentId][0].orderShipment.cost
                : orderShipments[shipmentId][0].orderShipment.supplierInputCost
            ).toFixed(2)
          ),
          phone: item.deliveryAddress.phonenumber ? item.deliveryAddress.phonenumber : defaultValue,
          businessName: item.deliveryAddress.businessName
            ? item.deliveryAddress.businessName
            : defaultValue,
          address1: item.deliveryAddress.address1 ? item.deliveryAddress.address1 : defaultValue,
          address2: item.deliveryAddress.address2 ? item.deliveryAddress.address2 : defaultValue,
          suburb: item.deliveryAddress.suburb ? item.deliveryAddress.suburb : defaultValue,
          city: item.deliveryAddress.city ? item.deliveryAddress.city : defaultValue,
          postcode: item.deliveryAddress.postcode ? item.deliveryAddress.postcode : defaultValue,
          region: item.deliveryAddress.regionId
            ? SHIPPING_REGIONS_ID_NAME[item.deliveryAddress.regionId]
            : defaultValue,
          country: item.deliveryAddress.regionId
            ? SHIPPING_REGIONS_ID_COUNTRY(item.deliveryAddress.regionId)
            : defaultValue,
          signatureRequired: item.signatureRequired === 1 ? 'Yes' : 'No',
          deliveryInstructions: item.deliveryInstructions,
          shippingStatusLabel: orderShipments[shipmentId][0].shippingStatusLabel,
          shippingEndsAt: orderShipments[shipmentId][0].shippingEndsAt,
          orderShipmentId: shipmentId,
          products: orderShipments[shipmentId].map(orderShipment => ({
            orderLineId: orderShipment.id,
            productTitle:
              orderShipment && orderShipment.product
                ? orderShipment.product.alternateTitle || orderShipment.product.title
                : '',
            productName:
              orderShipment && orderShipment.product
                ? orderShipment.product.alternateTitle || orderShipment.product.title
                : '',
            productId: orderShipment && orderShipment.product ? orderShipment.product.id : '',
            saleId: orderShipment.saleId,
            brand:
              orderShipment && orderShipment.product && orderShipment.product.brand
                ? orderShipment.product.brand.name
                : defaultValue,
            colour:
              orderShipment.productColour && orderShipment.productColour.colour
                ? orderShipment.productColour.colour
                : '',
            size: orderShipment.productSize ? orderShipment.productSize.size : '',
            productSKU: orderShipment.product.code ? orderShipment.product.code : '',
            productBarCode: orderShipment.productVariant.barcode
              ? orderShipment.productVariant.barcode
              : defaultValue,
            price:
              orderShipment && orderShipment.product
                ? orderShipment.product.price
                : defaultValueForNumber,
            cost: orderShipment.unitCost
              ? orderShipment.unitCost
              : orderShipment && orderShipment.product
                ? orderShipment.product.cost
                : defaultValueForNumber,
            // If nothing in amount means it is NZD, so amount is the same as the cost
            amount: orderShipment.unitCost
              ? orderShipment.unitCost
              : orderShipment &&
                orderShipment.product &&
                orderShipment.product.productCosts &&
                orderShipment.product.productCosts.length > 0
                ? orderShipment.product.productCosts[0].amount
                : orderShipment && orderShipment.product
                  ? orderShipment.product.cost
                  : defaultValueForNumber,
            currency: orderShipment.costCurrency
              ? orderShipment.costCurrency
              : orderShipment &&
                orderShipment.product &&
                orderShipment.product.productCosts &&
                orderShipment.product.productCosts.length > 0
                ? orderShipment.product.productCosts[0].currency
                : 'NZD',

            /**
             * If nothing in amount means it is NZD, so amount is the same as the cost
             *    NZD cost is GST included, Other cost is GST excluded
             */
            costWithoutGst: orderShipment.costCurrency
              ? parseFloat(
                  parseFloat(
                    orderShipment.costCurrency === 'nzd'
                      ? orderShipment.unitCost / GST_RATE
                      : orderShipment.unitCost
                  ).toFixed(2)
                )
              : parseFloat(
                  (
                    parseFloat(
                      orderShipment && orderShipment.product ? orderShipment.product.cost : 0.0
                    ) / GST_RATE
                  ).toFixed(2)
                ),
            /**
             * If nothing in amount means it is NZD, so amount is the same as the cost
             *    NZD cost is GST included, Other cost is GST excluded
             */
            amountWithoutGst: orderShipment.costCurrency
              ? parseFloat(
                  orderShipment.costCurrency === 'nzd'
                    ? orderShipment.unitCost / GST_RATE
                    : orderShipment.unitCost
                ).toFixed(2)
              : parseFloat(
                  (orderShipment &&
                  orderShipment.product &&
                  orderShipment.product.productCosts &&
                  orderShipment.product.productCosts.length > 0
                    ? parseFloat(orderShipment.product.productCosts[0].amount)
                    : parseFloat(
                        orderShipment && orderShipment.product ? orderShipment.product.cost : 0.0
                      ) / GST_RATE
                  ).toFixed(2)
                ),

            freightCost:
              orderShipment && orderShipment.product
                ? orderShipment.product.freightCost
                : defaultValue,
            quantity: orderShipment.quantity,
            quantityIncludeReturn:
              parseInt(orderShipment.quantity) -
              (orderShipment.orderModification && orderShipment.orderModification.returnQuantity
                ? parseInt(orderShipment.orderModification.returnQuantity)
                : 0),
            returnQuantity:
              orderShipment.orderModification && orderShipment.orderModification.returnQuantity
                ? parseInt(-orderShipment.orderModification.returnQuantity)
                : 0,
            cancelledQuantity:
              orderShipment.returnReason === 'Cancelled' && orderShipment.orderModification
                ? -parseInt(orderShipment.orderModification.quantity)
                : 0,
            supplierId:
              orderShipment && orderShipment.product
                ? orderShipment.product.supplierId
                : defaultValue,
            returnReason:
              orderShipment && orderShipment.returnReasonForMarketPlace
                ? orderShipment.returnReasonForMarketPlace
                : defaultValue,
            returnCreatedAt:
              orderShipment && orderShipment.orderModification
                ? orderShipment.orderModification.createdAt
                : defaultValue,
          })),
        };
        // is all returned, means orderline.quantity =0
        let isAllReturned = true;
        let isAllCancelledOrUnderSupply = true;
        order.products.forEach(product => {
          if (product.quantity > 0) {
            isAllReturned = false;
          }
          if (product.returnReason !== 'Cancelled' && product.returnReason !== 'Undersupply') {
            isAllCancelledOrUnderSupply = false;
          }
          if (!order.saleIds) {
            order.saleIds = [];
          }
          if (!order.supplierIds) {
            order.supplierIds = [];
          }
          if (!order.costs) {
            order.costs = [];
          }
          if (!order.costsWithoutGst) {
            order.costsWithoutGst = [];
          }
          if (!order.amounts) {
            order.amounts = [];
          }
          if (!order.currencies) {
            order.currencies = [];
          }
          if (!order.amountsWithoutGst) {
            order.amountsWithoutGst = [];
          }
          if (!order.freightCosts) {
            order.freightCosts = [];
          }
          if (!order.productShowName) {
            order.productShowName = [];
          }
          if (!order.productShowNameWithoutBarCode) {
            order.productShowNameWithoutBarCode = [];
          }
          if (!order.productIds) {
            order.productIds = [];
          }
          if (!order.quantity) {
            order.quantity = [];
          }
          if (!order.cancelledQuantity) {
            order.cancelledQuantity = [];
          }
          if (!order.skus) {
            order.skus = [];
          }
          if (!order.barCodes) {
            order.barCodes = [];
          }

          if (!order.returnReasons) {
            order.returnReasons = [];
          }
          if (!order.returnCreatedAts) {
            order.returnCreatedAts = [];
          }
          if (!order.quantityIncludeReturn) {
            order.quantityIncludeReturn = [];
          }
          if (!order.returnQuantity) {
            order.returnQuantity = [];
          }

          // initial value is the shipping cost, then plus each cost
          if (!order.totalCostIncludeReturnWithoutGst) {
            order.totalCostIncludeReturnWithoutGst = order.shippingCostWithoutGst;
          }
          if (!order.totalCostIncludeReturnWithoutShippingCostWithoutGst) {
            order.totalCostIncludeReturnWithoutShippingCostWithoutGst = 0;
          }
          if (!order.returnTotalCostWithoutShippingCostWithoutGst) {
            order.returnTotalCostWithoutShippingCostWithoutGst = 0;
          }
          order.totalCostIncludeReturnWithoutGst +=
            product.quantityIncludeReturn * product.amountWithoutGst;
          order.totalCostIncludeReturnWithoutShippingCostWithoutGst +=
            product.quantityIncludeReturn * product.amountWithoutGst;
          order.returnTotalCostWithoutShippingCostWithoutGst +=
            product.returnQuantity * product.amountWithoutGst;
          const productName = `${product.productName} ${
            product.colour ? ` - ${product.colour}` : ''
          } ${product.size ? ` - ${product.size}` : ''}`;
          if (product.productBarCode) {
            order.productShowName.push(`${product.productBarCode} - ${productName}`);
          } else {
            order.productShowName.push(productName);
          }
          order.productShowNameWithoutBarCode.push(
            `${product.productName} ${product.colour} ${product.size}`
          );
          order.quantity.push(product.quantity);
          order.cancelledQuantity.push(product.cancelledQuantity);
          order.returnCreatedAts.push(product.returnCreatedAt);
          order.returnReasons.push(product.returnReason);
          order.quantityIncludeReturn.push(product.quantityIncludeReturn);
          order.returnQuantity.push(product.returnQuantity);
          order.skus.push(product.productSKU);
          order.barCodes.push(product.productBarCode);
          order.productIds.push(product.productId);
          order.freightCosts.push(product.freightCost);
          order.costs.push(product.cost);
          order.currencies.push(product.currency);
          order.costsWithoutGst.push(product.costWithoutGst);
          order.amounts.push(product.amount);
          order.amountsWithoutGst.push(product.amountWithoutGst);
          order.supplierIds.push(product.supplierId);
          order.saleIds.push(product.saleId);
        });
        order.notAllReturnedShippingCostWithoutGst = 0;
        // If not returned quantity is more than 0, then record the notAllReturnedShippingCostWithoutGst
        if (isAllCancelledOrUnderSupply && isAllReturned) {
          order.notAllReturnedShippingCostWithoutGst = order.shippingCostWithoutGst;
        }
        order.returnTotalCostWithShippingCostWithoutGst =
          order.returnTotalCostWithoutShippingCostWithoutGst +
          order.notAllReturnedShippingCostWithoutGst;

        // delete item.products;
        orders.push(order);
      });
    });
    return orders;
  }
  return [];
};
const processRow = function(row) {
  let finalVal = '';
  for (let j = 0; j < row.length; j++) {
    let innerValue = row[j] === null || typeof row[j] === 'undefined' ? '' : row[j].toString();
    if (row[j] instanceof Date) {
      innerValue = row[j].toLocaleString();
    }
    let result = innerValue.replace(/"/g, '""');
    if (result.search(/("|,|\n)/g) >= 0) result = `"${result}"`;
    if (j > 0) finalVal += ',';
    finalVal += result;
  }
  return `${finalVal}\n`;
};
const transferToCSV = array => {
  let csvFile = '';
  array.forEach(item => {
    csvFile += processRow(item);
  });
  return csvFile;
};

/**
 * Get current date for statement:
 *  after 5 days to show the statement of the month
 * @return {*|{id, label, canSort}}
 */
const currentDateForStatement = () => {
  const currentDate = moment().subtract(4, 'd');
  if (currentDate.month() === moment().month()) {
    return moment().subtract(1, 'M');
  }
  return moment().subtract(2, 'M');
};
module.exports = {
  decorateData,
  transferToCSV,
  currentDateForStatement,
};



// WEBPACK FOOTER //
// ./src/components/common/OrderUtil.js